import { render, staticRenderFns } from "./CompanyData.vue?vue&type=template&id=24ba6beb"
import script from "./CompanyData.vue?vue&type=script&lang=js"
export * from "./CompanyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports